import { Injectable } from '@angular/core';
import { resource } from '@util/resource';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface AgreementInfo {
  id: string;
  name: string;
  fullText: string;
  acceptWineSuiteUpdates?: boolean;
  acceptExclusive?: boolean;
  remainingDaysToAccept?: number;
  timeToAccept?: number;
  mustAccept?: boolean;
  linksDoc?: string;
}

export interface AgreementAcceptance {
  id: string;
  acceptWineSuiteUpdates: boolean;
  acceptExclusive: boolean;
}

export interface TermsResult {
  success: boolean;
  message: string;
  agreementsInfoDto?: Array<AgreementInfo>;
}

export interface TermsAcceptResult {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsService {
  constructor() {}

  getTerms(type?: string): Observable<TermsResult> {
    const params: any = {};
    if (type) {
      params.type = type;
    }
    return resource('crm://terms-and-conditions')
      .params(params)
      .get<TermsResult>();
  }

  getTermsToBeAccepted(type?: string): Observable<TermsResult> {
    const params: any = {};
    if (type) {
      params.type = type;
    }
    return resource('crm://terms-and-conditions/to-accept')
      .params(params)
      .get<TermsResult>();
  }

  acceptTerms(agreementsAcceptance: AgreementAcceptance[]): Observable<TermsAcceptResult> {
    return resource('crm://terms-and-conditions')
      .post<TermsAcceptResult>(agreementsAcceptance);
  }

  /**
   * Returns the latest ToS acceptance timestamp (epoch seconds) for ws-payment agreements for the current winery.
   * Used when creating WSPayment (dwspay) accounts to pass Stripe tos_acceptance (WS-2376).
   * Returns null when no acceptance has been recorded (204 or error).
   */
  getLatestWsPaymentAcceptance(): Observable<{ timestampEpochSec: number } | null> {
    return resource('crm://terms-and-conditions/latest-ws-payment-acceptance')
      .get<{ timestampEpochSec: number }>()
      .pipe(
        catchError(() => of(null))
      );
  }
}
